module.exports = __webpack_public_path__ + "static/hero3-0e2c0886877b6c404f49c30fb5405647.jpg";